<template>
  <div>
    <data-table-card
      :items="items"
      v-on:updateData="getBrands"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons v-if="userHasPerms(['Manage products'])">
        <b-button
          class="ml-2"
          :to="{ name: 'brands-create' }"
          variant="primary"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:cards="slotProps">

          <router-link
            v-b-tooltip.hover
            :to="{
              name: 'brands-show',
              params: { id: slotProps.item.id },
            }"
            class="text-body pointer text-decoration-none"
          >
            <div class="row no-gutters">
              <div class="col-4 col-lg-3 p-1">
                <v-lazy-image
                  v-if="slotProps.item.image"
                  :src="slotProps.item.image"
                  class="img-fluid maxHeight100"
                />
              </div>
              <div class="col-8 col-lg-9 p-3">
                <h5 class="font-weight-bold">{{ slotProps.item.name }}</h5>
                {{ slotProps.item.products_count }} Products
              </div>
            </div>
          </router-link>

      </template>
    </data-table-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'brands' })"
      :lazy="true"
    >
      <router-view
        @brandCreated="brandCreated()"
        @brandUpdated="brandUpdated()"
      ></router-view>
    </b-modal>
  </div>
</template>

<script>
import brandRepo from "@/api/repos/brandRepo";
import dataTableCard from "@/components/common/DataTableCard";

export default {
  components: {
    dataTableCard: dataTableCard,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getBrands({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 12,
      search: "",
    });
  },
  methods: {
    async getBrands(e) {
      this.isLoad = true;
      try {
        let { data } = await brandRepo.brands(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.brands.data;
        this.totalRows = data.brands.total;
        this.page = data.brands.current_page;
        this.fromRow = data.brands.from;
        this.toRow = data.brands.to;
        this.lastPage = data.brands.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    brandCreated() {
      this.$bvToast.toast("Brand Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getBrands({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },

    brandUpdated() {
      this.$bvToast.toast("Brand Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getBrands({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem("rowsPerPage")
          ? localStorage.getItem("rowsPerPage")
          : 12,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
